// Translations for Origen Tech Website

export const translations = {
  en: {
    // Navigation
    nav: {
      about: "About",
      vision: "Vision",
      products: "Products",
      investors: "Investors",
      contact: "Contact",
      getInTouch: "Get in Touch",
    },
    
    // Hero Section
    hero: {
      badge: "Building the Future of Cross-Border Investment",
      headline1: "Building Digital Bridges for",
      headline2: "Investment in Latin America",
      subheadline: "Origen Tech develops technology that connects Latin American opportunities with North American investors and markets.",
      ourProducts: "Our Products",
      contactUs: "Contact Us",
    },
    
    // About Section
    about: {
      label: "About Us",
      title: "Connecting Markets, Creating Opportunities",
      paragraph1: "Origen Tech is an emerging technology company focused on building digital platforms that help connect investment opportunities in Latin America with residents and investors in the United States.",
      paragraph2: "Our mission is to create tools that make it easier for U.S. residents to explore and invest in opportunities in Latin America, especially in real estate. We also aim to help real estate professionals and developers in Latin America present their markets, projects, and opportunities to North American buyers and investors.",
      crossBorder: "Cross-Border",
      crossBorderDesc: "Bridging North and Latin American markets",
      realEstateFocus: "Real Estate Focus",
      realEstateDesc: "Specialized in property investment opportunities",
    },
    
    // Vision Section
    vision: {
      label: "Our Vision",
      title: "Opening New Economic Connections",
      description: "Our goal is to use technology to open new economic connections between North and Latin America by creating transparent and accessible digital platforms that benefit investors, professionals, and communities alike.",
      accessibleTitle: "Accessible Investment",
      accessibleDesc: "Making Latin American investment opportunities accessible to North American investors through intuitive digital platforms.",
      connectionTitle: "Market Connection",
      connectionDesc: "Helping real estate professionals in Latin America reach and connect with international buyers and investors.",
      transparentTitle: "Transparent Platforms",
      transparentDesc: "Building trust through transparent, reliable technology that serves both sides of the investment equation.",
    },
    
    // Products Section
    products: {
      label: "Our Products",
      title: "Introducing Our First Platform",
      badge: "Available Now",
      ecuahomeTitle: "Ecuahome",
      ecuahomeSubtitle: "Real Estate Platform for Latin America",
      ecuahomeDesc: "Ecuahome is a real estate platform designed to help users discover, promote, and connect with property opportunities in Latin America, with a special focus on Ecuador. The platform allows realtors, property owners, and developers to showcase their listings to a broader international audience.",
      feature1: "Discover properties across Latin America",
      feature2: "Connect with local real estate professionals",
      feature3: "Showcase listings to international buyers",
      feature4: "Special focus on Ecuador's real estate market",
      downloadApp: "Download the app:",
      downloadAppStore: "Download on the",
      appStore: "App Store",
      getItOn: "Get it on",
      googlePlay: "Google Play",
      scanPhone: "Or scan with your phone:",
      orVisit: "Or visit ecuahome.com",
    },
    
    // Investors Section
    investors: {
      label: "For Investors",
      title: "Join Us in Building the Future",
      paragraph1: "Origen Tech is an emerging company actively seeking investors and strategic partners who share our vision of building technology that connects opportunities across borders.",
      paragraph2: "We're looking for partners interested in supporting technology platforms that bridge markets between North America and Latin America. Together, we can create new pathways for economic growth and opportunity.",
      partnerWithUs: "Partner With Us",
      emailUs: "Email Us Directly",
    },
    
    // Contact Section
    contact: {
      label: "Contact Us",
      title: "Let's Start a Conversation",
      description: "Have questions about our platforms or interested in partnership opportunities? We'd love to hear from you.",
      getInTouch: "Get in Touch",
      email: "Email",
      phone: "Phone",
      website: "Website",
      sendMessage: "Send a Message",
      nameLabel: "Name",
      namePlaceholder: "Your name",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      messageLabel: "Message",
      messagePlaceholder: "How can we help you?",
      submitButton: "Send Message",
      sending: "Sending...",
      successMessage: "Message sent successfully! We'll get back to you soon.",
      errorMessage: "Something went wrong. Please try again or email us directly.",
    },
    
    // Footer
    footer: {
      description: "Building digital bridges for investment in Latin America. Origen Tech creates technology platforms that connect markets and create opportunities.",
      quickLinks: "Quick Links",
      contact: "Contact",
      copyright: "© {year} Origen Tech. All rights reserved.",
      backToTop: "Back to top",
    },
  },
  
  es: {
    // Navigation
    nav: {
      about: "Nosotros",
      vision: "Visión",
      products: "Productos",
      investors: "Inversionistas",
      contact: "Contacto",
      getInTouch: "Contáctanos",
    },
    
    // Hero Section
    hero: {
      badge: "Construyendo el Futuro de la Inversión Transfronteriza",
      headline1: "Construyendo Puentes Digitales para",
      headline2: "Inversión en América Latina",
      subheadline: "Origen Tech desarrolla tecnología que conecta oportunidades latinoamericanas con inversionistas y mercados norteamericanos.",
      ourProducts: "Nuestros Productos",
      contactUs: "Contáctanos",
    },
    
    // About Section
    about: {
      label: "Nosotros",
      title: "Conectando Mercados, Creando Oportunidades",
      paragraph1: "Origen Tech es una empresa tecnológica emergente enfocada en construir plataformas digitales que ayudan a conectar oportunidades de inversión en América Latina con residentes e inversionistas en Estados Unidos.",
      paragraph2: "Nuestra misión es crear herramientas que faciliten a los residentes de EE.UU. explorar e invertir en oportunidades en América Latina, especialmente en bienes raíces. También buscamos ayudar a profesionales inmobiliarios y desarrolladores en América Latina a presentar sus mercados, proyectos y oportunidades a compradores e inversionistas norteamericanos.",
      crossBorder: "Transfronterizo",
      crossBorderDesc: "Conectando mercados de Norte y Latinoamérica",
      realEstateFocus: "Enfoque Inmobiliario",
      realEstateDesc: "Especializado en oportunidades de inversión inmobiliaria",
    },
    
    // Vision Section
    vision: {
      label: "Nuestra Visión",
      title: "Abriendo Nuevas Conexiones Económicas",
      description: "Nuestro objetivo es usar la tecnología para abrir nuevas conexiones económicas entre Norte y Latinoamérica creando plataformas digitales transparentes y accesibles que beneficien a inversionistas, profesionales y comunidades por igual.",
      accessibleTitle: "Inversión Accesible",
      accessibleDesc: "Haciendo las oportunidades de inversión latinoamericanas accesibles a inversionistas norteamericanos a través de plataformas digitales intuitivas.",
      connectionTitle: "Conexión de Mercados",
      connectionDesc: "Ayudando a profesionales inmobiliarios en América Latina a conectar con compradores e inversionistas internacionales.",
      transparentTitle: "Plataformas Transparentes",
      transparentDesc: "Construyendo confianza a través de tecnología transparente y confiable que sirve a ambos lados de la ecuación de inversión.",
    },
    
    // Products Section
    products: {
      label: "Nuestros Productos",
      title: "Presentamos Nuestra Primera Plataforma",
      badge: "Disponible Ahora",
      ecuahomeTitle: "Ecuahome",
      ecuahomeSubtitle: "Plataforma Inmobiliaria para América Latina",
      ecuahomeDesc: "Ecuahome es una plataforma inmobiliaria diseñada para ayudar a los usuarios a descubrir, promover y conectar con oportunidades de propiedades en América Latina, con un enfoque especial en Ecuador. La plataforma permite a agentes inmobiliarios, propietarios y desarrolladores mostrar sus listados a una audiencia internacional más amplia.",
      feature1: "Descubre propiedades en toda América Latina",
      feature2: "Conecta con profesionales inmobiliarios locales",
      feature3: "Muestra listados a compradores internacionales",
      feature4: "Enfoque especial en el mercado inmobiliario de Ecuador",
      downloadApp: "Descarga la aplicación:",
      downloadAppStore: "Descárgalo en",
      appStore: "App Store",
      getItOn: "Consíguelo en",
      googlePlay: "Google Play",
      scanPhone: "O escanea con tu teléfono:",
      orVisit: "O visita ecuahome.com",
    },
    
    // Investors Section
    investors: {
      label: "Para Inversionistas",
      title: "Únete a Nosotros en la Construcción del Futuro",
      paragraph1: "Origen Tech es una empresa emergente que busca activamente inversionistas y socios estratégicos que compartan nuestra visión de construir tecnología que conecte oportunidades a través de fronteras.",
      paragraph2: "Buscamos socios interesados en apoyar plataformas tecnológicas que conecten mercados entre Norteamérica y Latinoamérica. Juntos, podemos crear nuevos caminos para el crecimiento económico y las oportunidades.",
      partnerWithUs: "Asóciate con Nosotros",
      emailUs: "Envíanos un Email",
    },
    
    // Contact Section
    contact: {
      label: "Contáctanos",
      title: "Iniciemos una Conversación",
      description: "¿Tienes preguntas sobre nuestras plataformas o te interesa explorar oportunidades de asociación? Nos encantaría saber de ti.",
      getInTouch: "Ponte en Contacto",
      email: "Correo",
      phone: "Teléfono",
      website: "Sitio Web",
      sendMessage: "Enviar un Mensaje",
      nameLabel: "Nombre",
      namePlaceholder: "Tu nombre",
      emailLabel: "Correo Electrónico",
      emailPlaceholder: "tu@correo.com",
      messageLabel: "Mensaje",
      messagePlaceholder: "¿Cómo podemos ayudarte?",
      submitButton: "Enviar Mensaje",
      sending: "Enviando...",
      successMessage: "¡Mensaje enviado con éxito! Te responderemos pronto.",
      errorMessage: "Algo salió mal. Por favor intenta de nuevo o envíanos un correo directamente.",
    },
    
    // Footer
    footer: {
      description: "Construyendo puentes digitales para la inversión en América Latina. Origen Tech crea plataformas tecnológicas que conectan mercados y crean oportunidades.",
      quickLinks: "Enlaces Rápidos",
      contact: "Contacto",
      copyright: "© {year} Origen Tech. Todos los derechos reservados.",
      backToTop: "Volver arriba",
    },
  },
};

export default translations;
